<template>
    <article class="feed_article">
        <a :href="feed.link" :title="feed.user.username" target="_blank">
            <figure class="feed_article--image">
                <img :src="feed.images.standard_resolution.url" :alt="feed.user.username">
            </figure>
        </a>
        <section class="feed_article--main">
            <h3 class="feed_article--username"><a :href="feed.link" :title="feed.user.username" class="feed_article--link" target="_blank">{{feed.user.full_name}}</a></h3>
            <time class="feed_article--time" :datetime="itemDate">{{itemDateMessage}}</time>
            <p class="feed_article--caption" v-html="itemCaption"></p>
        </section>
    </article>
</template>

<script>
export default {
    name: 'instagram-item',
    props: {
        feed: Object
    },
    data () {
        return {
        }
    },

    computed: {
        itemCaption: function () {
            if (this.feed.caption !== null) {
                let str = this.feed.caption.text
                str = str.toLowerCase()

                let tags = this.feed.tags
                for (let i = 0; i < tags.length; i++) {
                    let hastag = '#' + tags[i]
                    let hashtagLink = '<a href="https://www.instagram.com/explore/tags/' + tags[i] + '" title="' + tags[i] + '" target="_blank">' + hastag + '</a>'
                    str = str.replace(new RegExp(hastag, 'g'), hashtagLink)
                }
                str = str.replace(/(?:\r\n|\r|\n)/g, '<br>')

                return str
            } else {
                return ''
            }
        },

        itemDate: function () {
            return new Date(this.feed.created_time * 1000)
        },

        itemDateMessage: function () {
            let now = new Date()
            let d = this.itemDate
            let tabMonth = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ]
            if (now.getFullYear() === d.getFullYear()) {
                if (now.getMonth() === d.getMonth()) {
                    if (now.getDate() === d.getDate()) {
                        if (now.getHours() === d.getHours()) {
                            if (now.getMinutes() === d.getMinutes()) {
                                d = 'just now'
                            } else {
                                d = (now.getMinutes() - d.getMinutes() === 1 ? 'about 1 minute ago' : 'about ' + (now.getMinutes() - d.getMinutes()) + ' minutes ago')
                            }
                        } else {
                            d = (now.getHours() - d.getHours() === 1 ? 'about 1 hour ago' : 'about ' + (now.getHours() - d.getHours()) + ' hours ago')
                        }
                    } else {
                        if (now.getDate() - d.getDate() <= 7) {
                            d = (now.getDate() - d.getDate() === 1 ? 'about 1 day ago' : 'about ' + (now.getDate() - d.getDate()) + ' days ago')
                        } else {
                            d = d.getDate() + ' ' + tabMonth[d.getMonth()]
                        }
                    }
                } else if (now.getDate() - d.getDate() <= 0) {
                    d = d.getDate() + ' ' + tabMonth[d.getMonth()]
                } else {
                    d = (now.getMonth() - d.getMonth() === 1 ? 'about 1 month ago' : 'about ' + (now.getMonth() - d.getMonth()) + ' months ago')
                }
            } else {
                d = (now.getFullYear() - d.getFullYear() === 1 ? 'about 1 year ago' : 'about ' + (now.getFullYear() - d.getFullYear()) + ' years ago')
            }
            return d
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/InstagramItem.vue